import { render, staticRenderFns } from "./trainDetail.vue?vue&type=template&id=acb44406&scoped=true"
import script from "./trainDetail.vue?vue&type=script&lang=js"
export * from "./trainDetail.vue?vue&type=script&lang=js"
import style0 from "./trainDetail.vue?vue&type=style&index=0&id=acb44406&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acb44406",
  null
  
)

export default component.exports